import React, { DetailedHTMLProps, SelectHTMLAttributes } from "react";

import { IconProps } from "../../../icons";

// prettier-ignore
export type TailwindSize = 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 |  14 | 15 | 16 | 20 | 24 | 28 | 32  | 36 | 40 | 44 | 48;

export type AvatarProps = {
  src?: string;
  fallbackClassName?: string;
  imgClassName?: string;
  name?: string;
  size?: TailwindSize;
  alt: string;
  fallback?: React.ElementType<IconProps>;
  reverse?: boolean;
} & DetailedHTMLProps<SelectHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  (
    {
      src,
      fallback: FallbackIcon,
      fallbackClassName,
      imgClassName,
      size = 12,
      alt,
      reverse = false,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`flex-shrink-0 inline-block ${className}`} ref={ref}>
        {src && (
          <img
            className={`w-${size} h-${size} rounded-full object-cover shadow-sm ${imgClassName}`}
            src={src}
            alt={alt}
            {...props}
          />
        )}
        {!src && FallbackIcon && (
          <div
            className={`ring-2 ring-white w-${size} h-${size} rounded-full ${
              reverse ? "bg-dark-100" : "bg-light-0"
            } shadow-sm inline-flex items-center justify-center overflow-hidden`}
          >
            <FallbackIcon
              className={fallbackClassName || `w-6 h-6 ${
                reverse ? "text-light-0" : "text-dark-100"
              }`}
            />
          </div>
        )}
      </div>
    );
  }
);

export default React.memo(Avatar);
